// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1ymUbv2B","content":"_3Zneq6EI","title":"XYL3pQNX","second":"_1fqAL97n","dadosContainer":"_2pxRedDa","error":"IgTXcLnZ","inputfile":"_3QKXHN7_","labelfile":"_16Awk3xN","table":"_2HaVy1Xw","submitButton":"_1ncLYaB1","concluded":"_2EIi2LOo","missingInfo":"_28SJclM0","close":"FtJrTZZa","mobile-burger":"_3U7uQx4o","avatar-container":"_1bjzWOSL","avatar":"_32eYmq62","anchorUl":"_19y4tUVZ","mobile-hidden":"IYuh2o1q","mobile-list":"_3cf_U2MM"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/pages/UserBiometricPage/UserBiometricPage.styl
// module id = 546
// module chunks = 0